import {Injectable} from '@angular/core';
import {LocalStorageService} from "ngx-webstorage";

@Injectable({
    providedIn: 'root'
})
export class FBStorageService {

    constructor(private storage: LocalStorageService) {
    }

    get = <T>(key: string) => this.storage.retrieve(key) as T;

    set = <T>(key: string, value: T) => this.storage.store(key, value);

    delete = (key: string) => this.storage.clear(key);

}
